// extracted by mini-css-extract-plugin
module.exports = {"alertContainer":"public-template_iTEgn","childrenContainer":"public-template_1hvLn"};